import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import "./ForgotPassword.css";

const LOCAL_API_BASE_URL = "http://localhost:5000";
const RENDER_API_BASE_URL = "https://wecareehs-backend.onrender.com";
const API_BASE_URL = process.env.REACT_APP_USE_RENDER === "true" ? RENDER_API_BASE_URL : LOCAL_API_BASE_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(`Error: ${data.error || "Failed to send reset email."}`);
      } else {
        setMessage("Success: Reset link sent to your email.");
      }
    } catch (err) {
      console.error("Error sending reset email:", err);
      setMessage("Error: Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="split-login-container">
      {/* Left Visual Panel - Recovery Variant */}
      <div className="visual-panel recovery-visual">
        <div className="visual-content">
          <h1 className="visual-heading">Access<br />Recovery.</h1>
          <p className="visual-subtext">Securely restore access to your account.</p>
        </div>
        <div className="abstract-shape recovery-shape"></div>
        <div className="abstract-shape-2"></div>
      </div>

      {/* Right Form Panel */}
      <div className="form-panel">
        <div className="form-content">
          <div className="brand-logo-area">
            <div className="logo-dot"></div>
          </div>

          <div className="login-header">
            <h2>Forgot Password?</h2>
            <p>Enter your email to receive a recovery link.</p>
          </div>

          <form onSubmit={handleSubmit} className="split-form">
            <div className="minimal-input-group">
              <label>Email Address</label>
              <input
                type="email"
                className="minimal-input"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {message && (
              <div className={`status-message ${message.startsWith("Success") ? "success" : "error"}`}>
                {message}
              </div>
            )}

            <button type="submit" className="action-btn" disabled={loading}>
              {loading ? "Sending Link..." : "Send Reset Link"} <FaArrowRight />
            </button>
          </form>

          <div className="panel-footer">
            <button className="back-link" onClick={() => navigate("/login")}>
              <FaArrowLeft size={12} /> Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
